module.exports = __webpack_public_path__ + "media/images/photo/Group300-f941c553bf2d78a8a5211eb8cd9f8a12.png";